import { useState, type ReactNode } from 'react';
import { initialsOf } from '@domain/entities/Person';
import { useSessionState } from '../providers/SessionProvider';
import styles from './AppShell.module.css';

/**
 * La cara de quien entró, al pie del menú.
 *
 * Hasta el 9 oct 2026 aquí iban siempre las iniciales: el menú leía el nombre de
 * la sesión y la sesión no trae foto. Se notó el día que se cargaron los
 * retratos —la foto salía en el perfil y en las listas, y en el menú no—. La
 * ficha de quien entró sí la trae, y ya viaja junto a la sesión.
 *
 * Si la imagen no carga —sin red, o una URL cuyo token ya cambió— se vuelve a
 * las iniciales. Es el único avatar que está en las veinte pantallas, y un
 * icono de imagen rota ahí se vería en todas. Se recuerda **qué URL** falló y
 * no sólo que falló: una foto nueva se vuelve a intentar.
 */
export const SessionAvatar = (): ReactNode => {
  const { status } = useSessionState();
  const [failed, setFailed] = useState<string | null>(null);

  if (status.kind !== 'ready') return null;

  const { photoURL } = status.person;
  if (photoURL !== null && photoURL.length > 0 && photoURL !== failed) {
    return (
      <img
        src={photoURL}
        alt=""
        className={styles.avatar}
        // El nombre va al lado y el botón ya lo anuncia: la imagen es adorno.
        aria-hidden="true"
        onError={() => {
          setFailed(photoURL);
        }}
      />
    );
  }

  return (
    <span className={styles.avatar} aria-hidden="true">
      {initialsOf(status.session.displayName)}
    </span>
  );
};
